/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExpiredEmployeeDashboardApiModel { 
    employeeId: number;
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    expiredAssessiblesCount: number;
}

